import { BillingInfo, IPlan } from 'src/@types/billing';
import { axios } from 'src/utils/axios';

import { PaymentMethod } from '@stripe/stripe-js';
import { PlanBillingCycle } from 'src/@types/plans';

export async function getPlans(): Promise<IPlan[]> {
  const { data } = await axios.get<IPlan[]>(`/billing/plans`);

  return data;
}

export async function getSubscription(): Promise<BillingInfo> {
  const { data } = await axios.get<BillingInfo>(`/billing/subscription`);

  return data;
}

export async function firstUpgradeSubscription(
  planId: string,
  billingCycle = PlanBillingCycle.MONTHLY,
  couponId?: string,
): Promise<BillingInfo> {
  const { data } = await axios.post<BillingInfo>(`/billing/first-upgrade`, {
    planId,
    billingCycle,
    couponId,
  });

  return data;
}

export async function upgradeSubscription(
  planId: string,
  billingCycle = PlanBillingCycle.MONTHLY,
  couponId?: string,
): Promise<BillingInfo> {
  const { data } = await axios.put<BillingInfo>(`/billing/upgrade-plan`, {
    planId,
    billingCycle,
    couponId,
  });

  return data;
}

export async function changeCoupon(couponId: string): Promise<BillingInfo> {
  const { data } = await axios.put<BillingInfo>(`/billing/change-coupon`, {
    couponId,
  });

  return data;
}

export type CouponResponse = {
  id: string;
  amount_off: number;
  percent_off: number;
  valid: boolean;
};

export async function getCoupon(couponId: string): Promise<CouponResponse> {
  const { data } = await axios.get<CouponResponse>(
    `/billing/coupon?couponId=${couponId}`,
  );

  return data;
}

type AddCardPayload = {
  paymentMethod: PaymentMethod;
  defaultCard?: boolean;
};
export async function addCard(payload: AddCardPayload): Promise<BillingInfo> {
  const { data } = await axios.post<BillingInfo>(`/billing/card/add`, payload);

  return data;
}

export async function changeDefaultCard(cardId: string): Promise<BillingInfo> {
  const { data } = await axios.put<BillingInfo>(
    `/billing/card/change-default`,
    {
      card: cardId,
    },
  );

  return data;
}

export async function removeCard(cardId: string): Promise<BillingInfo> {
  const { data } = await axios.delete<BillingInfo>(
    `/billing/card/remove?card=${cardId}`,
  );

  return data;
}

export * as BillingRequests from './billing';
